import React, { useMemo } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Edmonton city centre — default view when a customer has no coordinates yet.
const DEFAULT_CENTER = [53.5461, -113.4938];

const pinIcon = L.divIcon({
  className: "",
  html: `<div style="width:22px;height:22px;border-radius:50% 50% 50% 0;background:#e11d48;border:2px solid #fff;transform:rotate(-45deg);box-shadow:0 1px 4px rgba(0,0,0,.4)"></div>`,
  iconSize: [22, 22],
  iconAnchor: [11, 22],
});

function Recenter({ position }) {
  const map = useMap();
  React.useEffect(() => {
    if (position) map.setView(position, Math.max(map.getZoom(), 15), { animate: true });
  }, [position?.[0], position?.[1]]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

function ClickHandler({ onPick }) {
  useMapEvents({
    click: (e) => onPick(e.latlng.lat.toFixed(6), e.latlng.lng.toFixed(6)),
  });
  return null;
}

export function LocationPicker({ lat, lng, onChange, editable = true, height = 220 }) {
  const parsed = useMemo(() => {
    const la = parseFloat(lat);
    const ln = parseFloat(lng);
    if (Number.isFinite(la) && Number.isFinite(ln) && !(la === 0 && ln === 0)) return [la, ln];
    return null;
  }, [lat, lng]);

  return (
    <div
      className="overflow-hidden rounded-md border border-border"
      style={{ height, isolation: "isolate" }}
      data-testid="customer-location-picker"
    >
      <MapContainer
        center={parsed || DEFAULT_CENTER}
        zoom={parsed ? 15 : 10}
        style={{ height: "100%", width: "100%" }}
        scrollWheelZoom={false}
      >
        <TileLayer attribution="&copy; OpenStreetMap contributors" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {editable && <ClickHandler onPick={onChange} />}
        {parsed && <Recenter position={parsed} />}
        {parsed && (
          <Marker
            position={parsed}
            icon={pinIcon}
            draggable={editable}
            eventHandlers={
              editable
                ? {
                    dragend: (e) => {
                      const p = e.target.getLatLng();
                      onChange(p.lat.toFixed(6), p.lng.toFixed(6));
                    },
                  }
                : undefined
            }
          />
        )}
      </MapContainer>
    </div>
  );
}
